import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  protected storage = window.sessionStorage;

  private keyPrefix = '';

  protected setStorage(storage: Storage): void {
    this.storage = storage;
  }

  setKeyPrefix(keyPrefix: string): void {
    this.keyPrefix = keyPrefix;
  }

  setItem<T>(key: string, value: T): void {
    this.storage.setItem(this.getKeyWithPrefix(key), JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const value = this.storage.getItem(this.getKeyWithPrefix(key));
    if (!value) {
      return null;
    }
    return JSON.parse(value);
  }

  removeItem(key: string): void {
    this.storage.removeItem(this.getKeyWithPrefix(key));
  }

  clear(): void {
    this.storage.clear();
  }

  private getKeyWithPrefix(key: string): string {
    return this.keyPrefix + key;
  }
}
